import { ENDPOINT } from '~/constants';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import {
  type SendInvoicePreviewParams,
  type SendInvoicePreviewResponse,
} from './types';

/**
 * Sends a preview of a reprocessing invoice that the user has created using the create forwarded invoice preview endpoint.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/send_invoice_preview_invoice_process__process_id__invoice_preview__preview_id__send_post
 */
export async function sendInvoicePreview({
  emailPreviewId,
  processId,
}: SendInvoicePreviewParams) {
  try {
    const response = await vestigasApi
      .post(
        ENDPOINT.INVOICE_REPROCESSING.SEND_INVOICE_PREVIEW(
          processId,
          emailPreviewId,
        ),
      )
      .json<SendInvoicePreviewResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error sending invoice preview',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(($) => $.sendInvoicePreview.error422, {
            ns: 'data',
          });
          break;
        }

        default: {
          errorMessage = i18n.t(($) => $.sendInvoicePreview.error.generic, {
            ns: 'data',
          });
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
}
